export default "__VITE_ASSET__665fb69b__"